export const getLocationHash = (brand?: string, year?: string, typeName?: string, modelId?: string, diagramId?: string) =>
  [brand, year, typeName, modelId, diagramId].filter((t) => t != undefined).join("-");

export const parseModelIdFromLocationHash = (locationHash: string) => {
  const parts = locationHash?.split("-");
  return parts.length > 3 ? parts[3] : undefined;
};
